<template>
  <!--
    TODO: Undo after Sam has a look.
    This z-index is to override the people page
  -->
  <div class="modal-container t-relative t-z-50">
    <ModalRenderer v-for="modal in modalState.modals" :key="modal.id" :modal="modal" />
  </div>
</template>

<script>
import { inject } from 'vue-demi';
import ModalRenderer from '@/platform/components/ModalRenderer';

export default {
  components: { ModalRenderer },
  setup() {
    const { modalManager } = inject('appFacade');

    return {
      modalState: modalManager.modalState,
    };
  },
};
</script>
